// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, PropsWithChildren } from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";

const borderWidth = pxToRem(1);
/* Starter Custom Code - End */

export interface CardContainerStyles {
    cardDivider?: InjectableCss;
    gridItem?: GridItemProps;
}

export const cardContainerStyles: CardContainerStyles = {
    cardDivider: {
        css: css`
            padding: ${pxToRem(22, 0)};
            border-top: ${borderWidth} solid ${getColor("common.border")};
            border-bottom: ${borderWidth} solid ${getColor("common.border")};
            margin-top: -${borderWidth};
        `,
    },
    gridItem: {
        width: 12,
        css: css`
            display: block;

            &:first-child > ${StyledWrapper} {
                margin-top: 0;
            }
        `,
    },
};

const CardContainer: FC<
    PropsWithChildren<{
        extendedStyles?: CardContainerStyles;
    }>
> = ({ extendedStyles, children }) => {
    const [styles] = React.useState(() => mergeToNew(cardContainerStyles, extendedStyles));

    /* Starter Custom - Moved StyledWrapper inside GridItem */
    return (
        <GridItem {...styles.gridItem}>
            <StyledWrapper {...styles.cardDivider} className="card_container__wrapper">
                {children}
            </StyledWrapper>
        </GridItem>
    );
};

export default CardContainer;
